import { render } from "./owl1314Page.vue?vue&type=template&id=2346bc41"
import script from "./owl1314Page.vue?vue&type=script&lang=js"
export * from "./owl1314Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__